<template lang="pug">
BriqTable(data-test-id="scheduled-products-table" class="border-style-hidden cell-padding-8-20")
  thead
    tr
      th Product
      th Time
      th Resource
      th Quantity
      th Exclusive
      th
  BookingDealTableSection(
    v-for="(bookingDeal, i) in bookingDeals"
    :key="bookingDealDomKey(bookingDeal, i)"
    :bookingDeal="bookingDeal"
    :products="products"
    :resources="resources"
    @deleteDeal="key => $emit('deleteDeal', key)"
    )
  tbody
    BookingProductsTableRow(
      v-for="bookingProduct in scheduledProductsWithoutDealAndExtras"
      :key="bookingProduct.Key"
      :bookingProduct="bookingProduct"
      :products="products"
      :resources="resources"
      :classifications="classifications"
      :isBookingSplitIntoMultipleProducts="false"
      @delete="p => $emit('deleteBookingProduct', p)"
      )
</template>

<script>
import { both, either, pipe, values, toString, reduce, concat } from 'ramda'
import { mapGetters } from 'vuex'
import TrashIconButton from '@v/bookings/edit/components/TrashIconButton.vue'
import BookingProductsTableRow from './BookingProductsTableRow.vue'
import BookingDealTableSection from './BookingDealTableSection.vue'
import DealQuantityPicker from '@v/bookings/edit/components/DealQuantityPicker.vue'
import DealProductType from '@v/bookings/edit/models/DealProductType.js'

export default {
  name: 'BookingProductsTable',
  components: {
    TrashIconButton,
    BookingDealTableSection,
    BookingProductsTableRow,
    DealQuantityPicker,
  },
  props: {
    booking: { type: Object, required: true }, // todo: only needs bookingproducts
    products: { type: Array, required: true },
    resources: { type: Object, required: true },
    classifications: Array,
  },
  data() {
    return {
      totalQuantitiesOfDealProductsPerDeal: {},
      quantitiesByProductGroupProductKey: {},
    }
  },
  computed: {
    ...mapGetters('bookingUpsert', ['bookingDeals', 'scheduledProductsIncHelper']),
    scheduledProductsWithoutDealAndExtras() {
      const isScheduled = p => p.NeedsToBeScheduled
      const notFromDeal = p => !p.ProductGroupKey
      const isExtra = p => p.DealProductType === DealProductType.CrossSell
      const valid = both(isScheduled, either(notFromDeal, isExtra))
      return this.booking.BookingProducts.filter(valid)
    },
  },
  methods: {
    bookingDealDomKey(bookingDeal, i) {
      // this is needed to update dom if bookingdeal quantities change
      // the scheduledProductsIncHelper is needed as a helper for the table to be rerendered if is the total quantities
      // are updated trough Number of participants, but not when you modifing trough QuantityPickerPerSegment
      return bookingDeal.dealKey + i + this.scheduledProductsIncHelper
    },
  },
}
</script>
